import { FormSections, FormSubSections, RedirectSection } from "../../entities/formTemplateDataType";
import { DialogBase, Props } from "./DialogBase";
import React from "react";
import { Dialog } from "primereact/dialog";
import { generateSectionIndex } from "../../utilities/ElementUtils";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { buttonClassList, FR_SUFFIX, SubmissionMethodList } from "../../entities/Constants";
import { Button } from "primereact/button";
import ErrorElement from "../../commonComponent/ErrorElement";
import { Editor } from "primereact/editor";
import Utils from "../../utilities/Utils";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";

interface State {
    pickedFieldOptions;
    statusCodeError?: string;
    statusCodeValue?: string;
    redirectPage?: RedirectSection;
}

class DialoagForCardButtonComponent extends DialogBase<Props,State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            pickedFieldOptions: [],
        };
    }

    componentDidMount(): void {
        if (this.props.ele.FilterField != null) {
            this.onChangeHanlder(this.props.ele.FilterField)
        }
    }


    onChangeHanlder = (newValue) => {
        this.props.ele.FilterField = newValue;
        let totalOption = [];
        let eleList = (this.props.ele.parent as FormSubSections).ListOfFormSectionElements.filter(p => p.Sequence < this.props.ele.Sequence)
        let pickedFieldOptions =  eleList.filter(
                    (ele) =>
                        this.props.isEng
                            ? ele.ENUTitle.replace(/\s/g, "") === newValue
                            : ele.FRATitle.replace(/\s/g, "") === newValue
                ).map((q) => {
                    const container = {};
                    container[
                        this.props.isEng
                            ? q.ENUTitle.replace(/\s/g, "")
                            : q.FRATitle.replace(/\s/g, "")
                    ] = q.ListOfLOVValues;
                    return container;
                });

                totalOption.push(...pickedFieldOptions);


        this.setState({ pickedFieldOptions: totalOption });
        this.props.callback();
    }

    handleStatusCodeChange = (e) => {
        const regex = /^[a-zA-Z0-9_-]+$/;
        const value = e.target.value as string;
        if (!value) {
            this.setState({ statusCodeError: "Status code is required" });
        } else if (!regex.test(value)) {
            this.setState({ statusCodeError: "Only alphanumeric is allowed" });
        } else {
            this.setState({ statusCodeError: undefined, statusCodeValue: value });
        }
    }

    addRoutingPage = (e) => {
        e.preventDefault();
        if (this.state.statusCodeValue && this.state.redirectPage?.redirectPage) {
            const statusCode = this.state.statusCodeValue?.trim();
            this.setState({statusCodeError: undefined});
            const route = this.state.redirectPage;
            route.statusCode = statusCode;
            this.props.ele.SubmitButton = this.props.ele.SubmitButton || {};
            this.props.ele.SubmitButton.apiSuccessRedirectPage = this.props.ele.SubmitButton.apiSuccessRedirectPage || [];
            this.props.ele.SubmitButton.apiSuccessRedirectPage.push(route);
            this.setState({statusCodeValue: undefined, redirectPage: undefined});
            this.props.callback();
        } else {
                this.setState({statusCodeError: "status code is required"});
        }
        
    }

    generateContentString = () => {
        let elementListWithOptions = [];
        const sectionIndex = generateSectionIndex(this.props.ele)

        let subSection = this.props.ele.parent as FormSubSections;
        let section = subSection.parent as FormSections;
        let listOfSubSectionToDuplicate = section.ListOfFormSubSections.filter(sub => sub.ENUTitle && sub.Id != subSection.Id && sub.CanBeDuplicate).map(sub => sub.ENUTitle);

        let list = subSection.ListOfFormSectionElements.filter(
            (q) =>
            (q.Datatype === "RadioButton" ||
                q.Datatype === "CheckGroup" ||
                q.Datatype === "Dropdown")
        ).map((q) => {
            return {
                code: this.props.isEng
                    ? q.ENUTitle?.replace(/\s/g, "")
                    : q.FRATitle?.replace(/\s/g, ""),
                description: this.props.isEng ? q.ENUTitle : q.FRATitle
            };
        });
        elementListWithOptions.push(...list);

        const valueArray = Array.isArray(this.props.ele.ClassName) ? this.props.ele.ClassName : [];

        let htmlString = [];
        htmlString.push(
            <div style={{ width: "100%", paddingTop: "5px" }}>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Field</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown style={{ width: '100%' }} showClear
                            options={elementListWithOptions}
                            className="ontario-dropdown-small"
                            optionLabel="description"
                            optionValue="code"
                            value={this.props.ele.FilterField?.replace(/\s/g, "")}
                            placeholder="Filtered by previous field"
                            onChange={(e) => {
                                this.onChangeHanlder(e.value);
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Value</div>
                    <div style={{ width: '60%', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Dropdown style={{ width: '100%' }} showClear
                            className="ontario-dropdown-small"
                            options={this.state.pickedFieldOptions[0] != null ? this.state.pickedFieldOptions[0][this.props.ele.FilterField] : null}
                            value={this.props.ele.FilterValue}
                            optionLabel="description"
                            optionValue="code"
                            placeholder="Filtering value"
                            onChange={(e) => {
                                this.props.ele.FilterValue = e.value;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                {this.stepperScriptHtml()}

                {this.initScriptHtml()}


                {this.scriptHtml()}

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Class(es)</div>
                    <div style={{ width: '60%' }}>
                        <MultiSelect key={"class_button_" + this.props.ele.Sequence}
                            options={buttonClassList}
                            optionLabel='label'
                            optionValue='val'
                            value={valueArray}
                            onChange={(e) => {
                                this.props.ele.ClassName = e.value;
                                this.props.callback();
                            }}></MultiSelect >
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Inline (Styling):</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        <Checkbox checked={this.props.ele.inlineStyling} value={this.props.ele.inlineStyling}
                            className='p-checkbox' title="Button is inline without line break"
                            onChange={(e) => {
                                this.props.ele.inlineStyling = e.checked;
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Subsection to duplicate</div>
                    <div style={{ width: '60%' }}>
                        <Dropdown showClear key={"class_button_" + this.props.ele.Sequence}
                            options={listOfSubSectionToDuplicate}
                            value={this.props.ele.SubSectionToDuplicate}
                            onChange={(e) => {
                                this.props.ele.SubSectionToDuplicate = e.value;
                                this.props.ele.ValidateStep = 'N';
                                this.props.ele.SubmitButton = {
                                    ...(this.props.ele.SubmitButton ?? {}), ValidateStep: 'N'
                                    };
    
                                this.props.callback();
                            }}
                        ></Dropdown>
                    </div>
                </div>


                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Validate Step</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Checkbox checked={this.props.ele.ValidateStep == 'Y' || this.props.ele.SubmitButton?.ValidateStep == 'Y'} value={this.props.ele.ValidateStep}
                            className='p-checkbox' title="Validate Step where button is"
                            onChange={(e) => {
                                this.props.ele.ValidateStep = e.checked ? 'Y' : 'N';
                                this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, ValidateStep: e.checked ? 'Y' : 'N' };
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Enable Recaptcha</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Checkbox checked={!!this.props.ele.Recaptcha || this.props.ele.SubmitButton?.enableRecaptcha} value={!!this.props.ele.Recaptcha}
                            className='p-checkbox' title="Enable Recaptcha"
                            onChange={(e) => {
                                this.props.ele.Recaptcha = e.checked ? {action: ''} : undefined;
                                this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, enableRecaptcha: e.checked ? e.checked : false };
                                this.props.callback();
                            }} />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Enable Pagination: </div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        {/* @ts-ignore */}
                        <Checkbox checked={this.props.ele.SubmitButton?.enablePanignation} value={!!this.props.ele.SubmitButton?.enablePanignation}
                            className='p-checkbox' title="Enable pagination"
                            onChange={(e) => {
                                this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, enablePanignation: e.checked ? e.checked : false };
                                this.props.callback();
                            }} />
                    </div>
                </div>
                <div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Icon: </div>
                        <div style={{ width: '60%' }}>
                            {!this.props.ele.displayInEditor && (
                                <Editor 
                                    value={this.props.isEng ? this.props.ele.callOutBoxBody : this.props.ele.callOutBoxBodyFRA}
                                    onTextChange={(e) => {
                                        if (this.props.isEng){
                                            // if(Utils.willDefaultFR(this.props.ele.callOutBoxBody, this.props.ele.callOutBoxBodyFRA)){
                                            //     this.props.ele.callOutBoxBodyFRA= Utils.isNullOrEmpty(e.htmlValue)? '' : e.htmlValue + FR_SUFFIX;
                                            // }
                                            this.props.ele.callOutBoxBody = e.htmlValue;
                                        }else{
                                            this.props.ele.callOutBoxBodyFRA = e.htmlValue;
                                        }
                                        this.props.callback();
                                    }}
                                />
                            )}
                            {this.props.ele.displayInEditor && (
                                <InputTextarea
                                    value={this.props.isEng ? this.props.ele.callOutBoxBody : this.props.ele.callOutBoxBodyFRA} 
                                    onChange={(e) => {
                                        this.props.isEng ? this.props.ele.callOutBoxBody = e.target.value : this.props.ele.callOutBoxBody = e.target.value
                                        this.props.callback();
                                    }}
                                />
                            )}
                        </div>
                    </div>
                    {((this.props.isEng && this.props.ele.callOutBoxTitle) || (!this.props.isEng && this.props.ele.callOutBoxTitleFRA)) && (
                        <div style={{ display: "flex", marginTop: '10px'  }}>
                            <div style={{ width: '25%' }}></div>
                            <div style={{ width: '60%' }}>
                                <button onClick={() => {
                                    this.props.ele.displayInEditor = !this.props.ele.displayInEditor;
                                    this.props.callback();
                                    }}
                                >
                                    {this.props.ele.displayInEditor == true ? "Raw" : "HTML"}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
                <div>
                    <div style={{ display: "flex", marginTop: '2.5rem' }}>
                        <div style={{ width: '25%' }}>Card Content</div>
                        <div style={{ width: '60%' }}>
                            {!this.props.ele.displayInEditor && (
                                <Editor
                                    value={this.props.isEng ? this.props.ele.callOutBoxTitle : this.props.ele.callOutBoxTitleFRA}
                                    onTextChange={(e) => {
                                        if (this.props.isEng){
                                            if(Utils.willDefaultFR(this.props.ele.callOutBoxTitle, this.props.ele.callOutBoxTitleFRA)){
                                                this.props.ele.callOutBoxTitleFRA= Utils.isNullOrEmpty(e.htmlValue)? '': e.htmlValue+ FR_SUFFIX;
                                            }
                                            this.props.ele.callOutBoxTitle = e.htmlValue;
                                        }else{
                                            this.props.ele.callOutBoxTitleFRA = e.htmlValue;
                                        }
                                        this.props.callback();
                                    }}
                                />
                            )}
                            {this.props.ele.displayInEditor && (
                                <InputTextarea
                                    value={this.props.isEng ? this.props.ele.callOutBoxTitle : this.props.ele.callOutBoxTitleFRA} 
                                    onChange={(e) => {
                                        this.props.isEng ? this.props.ele.callOutBoxTitle = e.target.value : this.props.ele.callOutBoxTitleFRA = e.target.value
                                        this.props.callback();
                                    }}
                                />
                            )}
                        </div>
                    </div>
                    {((this.props.isEng && this.props.ele.callOutBoxTitle) || (!this.props.isEng && this.props.ele.callOutBoxTitleFRA)) && (
                        <div style={{ display: "flex", marginTop: '10px'  }}>
                            <div style={{ width: '25%' }}></div>
                            <div style={{ width: '60%' }}>
                                <button onClick={() => {
                                    this.props.ele.displayInEditor = !this.props.ele.displayInEditor;
                                    this.props.callback();
                                    }}
                                >
                                    {this.props.ele.displayInEditor == true ? "Raw" : "HTML"}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
                
                { this.props.ele.Recaptcha && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Recaptcha action:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            <InputText className="ontario-input" 
                                value={this.props.ele.Recaptcha.action || this.props.ele.SubmitButton?.recaptchaAction} 
                                onChange={(e) => {
                                    this.props.ele.Recaptcha.action = e.target.value;
                                    this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, recaptchaAction: e.target.value };
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>API</div>
                    <div style={{ width: '60%'}}>                  
                        <InputText className="ontario-input" 
                            value={this.props.ele.Api || this.props.ele.SubmitButton?.api} 
                            onChange={(e) => {
                                this.props.ele.Api = e.target.value;
                                this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, api: e.target.value };
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                {(this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>API-Key:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            <div >
                                <InputText className="ontario-input"
                                    value={this.props.ele.SubmitButton?.apiKeyKey}
                                    placeholder="Key"
                                    title="API-Key Key"
                                    onChange={(e) => {
                                        this.props.ele.ApiKeyKey = e.target.value;
                                        this.props.ele.SubmitButton = { ...this.props.ele.SubmitButton ?? {}, apiKeyKey: e.target.value };
                                        this.props.callback();
                                    }}
                                />
                            </div>
                            <div>
                                <InputText className="ontario-input"
                                    value={this.props.ele.SubmitButton?.apiKeyValue}
                                    placeholder="Value"
                                    title="API-Key Value"
                                    onChange={(e) => {
                                        this.props.ele.ApiKeyValue = e.target.value;
                                        this.props.ele.SubmitButton = { ...this.props.ele.SubmitButton ?? {}, apiKeyValue: e.target.value };
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {(this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Method</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            {/* @ts-ignore */}
                            <Dropdown style={{ width: '100%' }} showClear
                                className="ontario-dropdown-small"
                                options={SubmissionMethodList}
                                value={this.props.ele.SubmissionMethod || this.props.ele.SubmitButton?.SubmissionMethod}
                                optionLabel='label'
                                optionValue='val'
                                placeholder="SubmissionMethod"
                                onChange={(e) => {
                                    this.props.ele.SubmissionMethod = e.value;
                                    this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, SubmissionMethod: e.value };
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}
                {(this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Response field name:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            <InputText className="ontario-input" 
                                value={this.props.ele.SubmitButton?.responseDataName} 
                                onChange={(e) => {
                                    this.props.ele.Api = e.target.value;
                                    this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, responseDataName: e.target.value };
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}
                { (this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>API error redirect to:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            {/* @ts-ignore */}
                            <Dropdown style={{ width: '100%' }} showClear
                                className="ontario-dropdown-small"
                                options={sectionIndex}
                                value={this.props.ele.SubmitButton?.apiErrorRedirectPage}
                                optionLabel='title'
                                optionValue='sequence'
                                placeholder="Page to redirect to"
                                onChange={(e) => {
                                    const sequence = Number(e.value);
                                    this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, apiErrorRedirectPage: isNaN(sequence) ? undefined : sequence};
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}
                { (this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Max API attempts:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            <InputText className="ontario-input" 
                                type="number"
                                min="1"
                                max="10"
                                value={String(this.props.ele.SubmitButton?.maxApiAttempts || '')} 
                                onChange={(e) => {
                                    const attempts = Number(e.target.value);
                                    this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, maxApiAttempts: isNaN(attempts) || attempts < 1 ? 1 : attempts};
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}
                { (this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>API success routes:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            <div style={{ width: '100%', marginTop: '5px' }}>
                                {this.props.ele.SubmitButton?.apiSuccessRedirectPage?.length > 0 && (
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                            {this.props.ele.SubmitButton?.apiSuccessRedirectPage?.map((item, index) => {
                                                return (
                                                    <tr key={`success-routing-${index}`}>
                                                        <td style={{ width: '20%' }}>
                                                            {item.statusCode}
                                                        </td>
                                                        <td style={{ width: '50%' }}>
                                                            {item.title}
                                                        </td>
                                                        <td style={{ width: '30%' }}>
                                                            <Button label="Delete" icon="pi pi-times" onClick={(e) => {
                                                                e.preventDefault();
                                                                this.props.ele.SubmitButton.apiSuccessRedirectPage.splice(index, 1);
                                                                this.props.callback();
                                                            }} />
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                )}
                                
                            </div>
                            <ErrorElement
                                display={!!this.state.statusCodeError}
                                message={this.state.statusCodeError}
                            />
                            <div style={{ width: '100%', marginTop: '5px', display: 'flex', justifyContent: 'space-between' }}>
                                <>
                                    <InputText className="ontario-input"
                                        style={{ width: '20%' }}
                                        value={this.state.statusCodeValue || ''}
                                        maxLength={10}
                                        placeholder="Status code"
                                        onChange={this.handleStatusCodeChange}
                                    />
                                    
                                    {/* @ts-ignore */}
                                    <Dropdown style={{ width: '50%' }} showClear
                                        className="ontario-dropdown-small"
                                        options={sectionIndex}
                                        value={this.state.redirectPage?.redirectPage}
                                        optionLabel='title'
                                        optionValue='sequence'
                                        placeholder="Page to redirect to"
                                        onChange={(e) => {
                                            const sequence = Number(e.value)
                                            const section = sectionIndex?.filter(p => p.sequence === sequence)[0];
                                            this.setState({redirectPage: { redirectPage: isNaN(sequence) ? undefined : sequence, title: section.title, statusCode: this.state.statusCodeValue ? this.state.statusCodeValue.trim() : undefined }});
                                            this.props.callback();
                                        }}
                                    />
                                    <Button style={{width: '30%'}} label="Add" onClick={(e) => {this.addRoutingPage(e)}} />
                                </>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );

        return htmlString;
    };

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Button properties for " + this.props.ele.ENUTitle : "Section properties for" + this.props.ele.FRATitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.generateContentString()}
                </Dialog>
            </>
        );
        return html;
    }


    render() {

        return (
            <>
                {this.generateHtmlString()}
            </>
        );
    }
}

export default DialoagForCardButtonComponent;